export default "__VITE_ASSET__1fddaee7__"